import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Powernaps and gambling",
  "description": "",
  "published": "2009-01-13T00:00:00.000Z",
  "redirect_from": ["/blog/powernaps-and-gambling/swizec/18"],
  "categories": "improvement, life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Powernapping is a practice of having a `}{`_`}{`short sleep which terminates before the occurrence of deep sleep or slow-wave sleep (SWS), intended to quickly revitalize the subject from drowsiness. `}{`_`}{`as per wikipedia. Somehow I've never been one for powernaps, but last night I was so knackered and still had so much to do that I decided to go and try have a powernap. Knackerness came from having walked to and from the gym in cold weather, it's a thirty minute walk each way ... anyhow.`}</p>
    <p>{`Because I remember my past experience with powernaps I'd decided to try doing it with a movie on, that should keep me focused and get up soon enough right? Well, no, I woke up this morning, six hours later. Some powernap! And so I found that gambling didn't work out at all this time and I probably won't try having a powernap ever again.`}</p>
    <p>{`However, I do remember once making good use of a technique much similar to powernapping, the so called meditation. I used to push myself into REM every midnight like clockwork, stay in REM for about ten or so minutes and then get back to work. Doing this I could sleep for an average of three or four hours a night without much trouble at all, but somehow, over the years I've gotten less and less punctual with my meditations until they finally became quite sporadic and to the current point where I'm lucky if I meditate three times a week.`}</p>
    <p>{`This has got to change, as @gregbrand said, "just do it". And he's right, I should just stop whining and go fucking meditate every midnight when the alarm goes off. NOT pushing the alarm forward two hours and then just turning it off. No, I WILL meditate and I `}{`_`}{`will `}{`_`}{`get my previous ability of instameditation back. It's going to take a lot of practice, but I'm gonna stick with it. Hell, if I can go to the gym every day for two hours, I should be able to take 20 minutes a night and force myself to meditate right?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      